import {
    // RESET_REPORT_USAGE_STATES,
    RESET_VALIDATED_DATA,
    STORE_SURGERY_DETAILS,
    RESET_CONSIGNMENT_MYCASEREF_REFERENCE,
    SET_PATIENT_DETAILS,
    STORE_ITEM_TABLE_DATA,
    GET_USAGE_DETAILS_SUCCESS,
    GET_USAGE_DETAILS_FAILURE,
    // CREATE_USAGE_ORDER,
    // CREATE_USAGE_ORDER_SUCCESS,
    // CREATE_USAGE_ORDER_FAILURE,
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    // GET_DROPDOWN_OPTIONS_SUCCESS,
    // GET_DROPDOWN_OPTIONS_FAILURE,
    VALIDATE_MAZOR_CODE_RESPONSE,
    // GET_PROCEDURE_INFO_SUCCESS,
    // GET_PROCEDURE_INFO_FAILURE,
    VALIDATE_PRODUCT_DETAILS,
    VALIDATE_PRODUCT_DETAILS_SUCCESS,
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    UPDATE_USAGE_ORDER_SUCCESS,
    UPDATE_USAGE_ORDER_FAILURE,
    DELETE_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_FAILURE,
    UPDATE_USAGE_ORDER,
    SET_ALL_ACCOUNT_OWNED_SELECTED,
    SET_PROCEDURE_DETAILS,
    SET_PRICE_OVERRIDE_DETAILS,
    RESET_ITEMTABLE_DATA,
    SHOW_HIDE_CONSIGNMENT_FOOTER,
    CHECK_IS_PRICEOVERRIDE_PAGE,
    CHECK_IS_PRODUCT_VALIDATION,
    SAVE_CONSIGNMENT_ORDER,
    PRICE_OVERRIDE_REASON,
    RESET_IS_FOR_REPLEN,
    SET_PRICEOVERRIDE_BTN,
    SET_PRICEITEM_BTN,
    CHECK_IS_BACK_FROM_INVENTORY,
    RESET_IS_FOR_PRICEOVERRIDE,
    CEAR_PRICE_OVER_RIDE,
    SET_PRICE_OVERRIDE,
    PRICE_OVERRIDE_NOTES,
    RESET_PRICEOVERRIDE_DATA,
    SET_COPY_ITEM_TABLE_DATA,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    myCaseRefId: null,
    myCaseResourceType: null,
    fromOrdersList: false,
    usageDetails: {},
    itemTableData: [],
    isCreateUsage: false,
    pricedItems: null,
    isPriceOverRide: false,
    priceOverRideDetails: {},
    validateMazorCodeRes: null,
    procedureInfoDetails: {},
    validProducts: null,
    priceOverrideReason: '',
    isProductValidationDone: false,
    isProductsValidationInProgress: false,
    isUsageAttachmentUploaded: false,
    isUpdateUsageDone: false,
    isProductValidationInProgress: false,
    isdeletionDone: false,
    isForReplen: false,
    patientDetails: {
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
    },
    dropdownData: {},
    localSignatureDetails: {
        base64Image: '',
        dateOfSignature: '',
    },
    signatureItemState: [],
    isAllAccountOwnedSelected: false,
    setProcedureDetails: [],
    showConsignmentFooter: true,
    isPriceOverridePage: false,
    consignmentOrderDetails: [],
    isForPriceOverride: false,
    isPriceItemBtnDisabled: false,
    isPriceOverrideBtnDisabled: true,
    isBackFromInventory: false,
    pricingNotes: '',
    itemTableDataCopy: [],
    priceOverrideReasonCopy:'',
    pricingNotesCopy:'',
};

const reportUsageRootReducer = (state = initialState, action = {}) => {
    // console.log('action for reducer', action);
    // debugger
    switch (action.type) {
        // case RESET_REPORT_USAGE_STATES:
        //     return {
        //         ...initialState,
        //     };
        case RESET_CONSIGNMENT_MYCASEREF_REFERENCE:
            return {
                ...state,
                myCaseRefId: null,
                myCaseResourceType: null,
                fromOrdersList: false,
            };
        case STORE_SURGERY_DETAILS:
            return {
                ...state,
                surgeryData: action.payload,
                myCaseRefId:
                    action.payload && action.payload.myCaseRef
                        ? action.payload.myCaseRef
                        : state.myCaseRefId,
                myCaseResourceType:
                    action.payload && action.payload.resourceType
                        ? action.payload.resourceType
                        : state.myCaseResourceType,
                fromOrdersList:
                    action.payload && action.payload.fromOrdersList
                        ? action.payload.fromOrdersList
                        : state.fromOrdersList,
            };
        case GET_USAGE_DETAILS_SUCCESS:
        case GET_USAGE_DETAILS_FAILURE:
            return {
                ...state,
                usageDetails: action.payload,
            };
        case SET_PATIENT_DETAILS:
            return {
                ...state,
                patientDetails: action.payload.patientDetails,
                usageDetails: {
                    ...state.usageDetails,
                    hrefId: action.payload.patientDetails.hrefId,
                    patientFirstName:
                        action.payload.patientDetails.patientFirstName,
                    patientLastName:
                        action.payload.patientDetails.patientLastName,
                },
            };
        case STORE_ITEM_TABLE_DATA:
            return {
                ...state,
                itemTableData: action.payload,
            };
            case SET_COPY_ITEM_TABLE_DATA:
                return {
                    ...state,
                    itemTableDataCopy: action.payload.items||[],
                    priceOverrideReasonCopy:action.payload?.priceOverrideReason||'',
                    pricingNotesCopy:action.payload?.pricingNotes||''
                };
        case RESET_ITEMTABLE_DATA:
            return {
                ...state,
                itemTableData: [],
                isPriceOverRide: false,
            };
        // case CREATE_USAGE_ORDER_SUCCESS:
        //     return {
        //         ...state,
        //         isCreateUsage: action.payload,
        //     };
        // case CREATE_USAGE_ORDER_FAILURE:
        //     return {
        //         ...state,
        //         isCreateUsage: false,
        //     };
        case 'CONSIGNMENT:STORE_ITEMS_DURING_PRICING':
            return {
                ...state,
                itemsToBePriced: action.payload,
            };
        case GET_PRICES_FOR_ITEMS_SUCCESS:
        case GET_PRICES_FOR_ITEMS_FAILURE:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingDone: action.payload.isPricingDone,
            };
        case RESET_VALIDATED_DATA:
            return {
                ...state,
                validProducts: null,
                isProductValidationDone: false,
                pricedItems: null,
                itemsToBePriced: null,
            };
        // case GET_DROPDOWN_OPTIONS_SUCCESS:
        //     return {
        //         ...state,
        //         dropdownData: {
        //             [action.payload.dropdownName]:
        //                 action.payload.dropdownOptions,
        //         },
        //     };
        // case GET_DROPDOWN_OPTIONS_FAILURE:
        //     return {
        //         ...state,
        //         dropdownData: action.payload,
        //     };
        case VALIDATE_MAZOR_CODE_RESPONSE:
            return {
                ...state,
                validateMazorCodeRes: action.payload,
            };
        // case GET_PROCEDURE_INFO_SUCCESS:
        // case GET_PROCEDURE_INFO_FAILURE:
        //     return {
        //         ...state,
        //         procedureInfoDetails: action.payload,
        //     };
        case VALIDATE_PRODUCT_DETAILS:
            return {
                ...state,
                // isProductsValidationInProgress: true,
                isForReplen: action.payload.isForReplen,
                isForPriceOverride: action.payload.isForPriceOverride,
            };
        case VALIDATE_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                validProducts: action.payload.validItems,
                isProductValidationDone: action.payload.productsValidated,
                // isForReplen: action.payload.isForReplen,
                // isForPriceOverride: action.payload.isForPriceOverride,
                // isProductsValidationInProgress: false,
            };
        case VALIDATE_PRODUCT_DETAILS_FAILURE:
            return {
                ...state,
                validProducts: action.payload.validItems,
                isProductValidationDone: action.payload.productsValidated,
                // isForReplen: action.payload.isForReplen,
                // isForPriceOverride: action.payload.isForPriceOverride,
                // isProductsValidationInProgress: false,
            };
        case RESET_IS_FOR_REPLEN:
            return {
                ...state,
                isForReplen: action.payload,
            };

        // case RESET_IS_FOR_PRICE_OVERRIDE:
        //     return {
        //         ...state,
        //         isForPriceOverride:action.payload
        //     };
        // case USAGE_ATTACHMENT_UPLOAD_SUCCESS:
        //     return {
        //         ...state,
        //         isUsageAttachmentUploaded: action.payload,
        //     };
        // case USAGE_ATTACHMENT_UPLOAD_FAILURE:
        //     return {
        //         ...state,
        //         isUsageAttachmentUploaded: false,
        //     };
        case UPDATE_USAGE_ORDER_SUCCESS:
            return {
                ...state,
                isUpdateUsageDone: action.payload,
            };
        case UPDATE_USAGE_ORDER:
            return {
                ...state,
                isUpdateUsageDone: action.payload,
            };
        // case CREATE_USAGE_ORDER:
        //     return {
        //         ...state,
        //         isUpdateUsageDone: action.payload,
        //     };
        case UPDATE_USAGE_ORDER_FAILURE:
            return {
                ...state,
                isUpdateUsageDone: false,
            };
        case DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                isdeletionDone: action.payload,
            };
        case DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
            };
        case 'SET_LOCAL_SIGNATURE': {
            return {
                ...state,
                localSignatureDetails: action.payload,
            };
        }
        case 'SET_ITEM_STATE_SIGNATURE': {
            return {
                ...state,
                signatureItemState: action.payload,
            };
        }
        case SET_ALL_ACCOUNT_OWNED_SELECTED: {
            return {
                ...state,
                isAllAccountOwnedSelected: action.payload,
            };
        }
        case SET_PRICE_OVERRIDE_DETAILS:
            return {
                ...state,
                priceOverRideDetails: action.payload,
                itemTableData: action.payload,
                isPriceOverRide:
                    action.payload.priceOverriddenReason !== '' &&
                    action.payload.priceOverriddenReason !== null &&
                    action.payload.priceOverriddenReason !== undefined
                        ? true
                        : false,
            };

        case SET_PRICE_OVERRIDE:
            return {
                ...state,
                isPriceOverRide: action.payload,
            };

        case CHECK_IS_PRICEOVERRIDE_PAGE:
            return {
                ...state,
                isPriceOverridePage: action.payload,
            };
        case CHECK_IS_PRODUCT_VALIDATION:
            return {
                ...state,
                isProductValidationInProgress: action.payload,
            };
        case SET_PROCEDURE_DETAILS: {
            return {
                ...state,
                setProcedureDetails: action.payload,
            };
        }
        case SHOW_HIDE_CONSIGNMENT_FOOTER: {
            return {
                ...state,
                showConsignmentFooter: action.payload,
            };
        }
        case SAVE_CONSIGNMENT_ORDER: {
            return {
                ...state,
                consignmentOrderDetails: action.payload,
            };
        }
        case PRICE_OVERRIDE_REASON: {
            return {
                ...state,
                priceOverrideReason: action.payload,
            };
        }
        case PRICE_OVERRIDE_NOTES: {
            return {
                ...state,
                pricingNotes: action.payload,
            };
        }

        case CEAR_PRICE_OVER_RIDE: {
            return {
                ...state,
                isPriceOverRide: false,
            };
        }

        case SET_PRICEOVERRIDE_BTN: {
            return {
                ...state,
                isPriceOverrideBtnDisabled: action.payload,
            };
        }
        case SET_PRICEITEM_BTN: {
            return {
                ...state,
                isPriceItemBtnDisabled: action.payload,
            };
        }
        case CHECK_IS_BACK_FROM_INVENTORY: {
            return {
                ...state,
                isBackFromInventory: action.payload,
            };
        }

        case RESET_IS_FOR_PRICEOVERRIDE: {
            return {
                ...state,
                isForPriceOverride: action.payload,
            };
        }
        case RESET_PRICEOVERRIDE_DATA: {
            return {
                ...state,
                priceOverRideDetails: {},
            };
        }
        default:
            return {
                ...state,
            };
    }
};

// export default reportUsageRootReducer;
export default persistReducer(
    {
        key: 'consignmentBillingReducer',
        storage: storage,
        whitelist: [
            'itemTableData',
            'priceOverrideReason',
            'consignmentOrderDetails',
            'isPriceOverRide',
            'pricingNotes'
        ],
    },
    reportUsageRootReducer
);
